import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ProjetosService {
private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getProjetos(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idContrato: string | null,
    filterParametro: string | null,
    filterData:any | null,
    statusFilter: any,
    tipoProjeto?: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('nomeOuNumeroContrato', filterParametro || filterData?.value?.contractNumber || '' )
      .set('codigoOuDescricaoServico', filterData?.value?.codigo || '')
      .set('nomeTipoProjeto', tipoProjeto || filterData?.value?.nomeTipoProjeto || '')
      
      if (statusFilter && statusFilter != 'Todos') {
        statusFilter.forEach((status: any) => params = params.append('statusAtuais', status.label || status.descricao))
      }
    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao`, { params });
  }
  getProjeto(idProjeto:any){
        return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}`);
  }
  buscarContratosParaFiltro(sortField: string = 'contractNumber', sortDirection: string = 'asc') {
    const params = new HttpParams()
      .set('sortField', sortField)
      .set('sortDirection', sortDirection);
    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/filtros/contratos`, { params });
  }
  getProjetoEdicao(idProjeto:any){
        return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/edicao`);
  }
  updateProjeto(idProjeto: string, formData: FormData) {
  return this.http.put(`${this.baseUrl}/v1/projetos/servicos-ampliacao/${idProjeto}`, formData);
}
  getInformacoesComplementaresProjeto(idProjeto:any){
        return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/informacoes-complementares`);
  }
  editarDisciplina(idProjeto:any, idDisciplina:any, formData: FormData){
    return this.http.put(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}`, formData )
  }
  getDisciplinas() {
    return this.http.get(this.baseUrl + `/v1/disciplinas?page=0&size=100&sortDirection=asc&sortField=nome`);
  }
  getDisciplinasCadastradasPorIdPaginada(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idProjeto:string) {
       let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')


    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas`, { params });
  }
  getAnalisesProjeto(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idProjeto: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');

    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/analises`, { params });
  }
  getDisciplinasCadastradasPorId(idProjeto:string) {
    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas?page=0&size=10&sortField=id&sortDirection=asc&nomeDisciplinaOuNomeVolume=&nomeDisciplina=`);
  }
  getDisciplinaPorId(idProjeto: string,idDisciplina: string) {
    return this.http.get(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}`);
  }
  createProjeto(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao`, formData);
  }
  createDisciplinaVolume(idProjeto:string, formData: FormData){
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas`, formData);
  }
  deleteProjeto(id:any) {
    return this.http.delete(this.baseUrl + `/v1/projetos/servicos-ampliacao/${id}`);
  }
  getHistorico(id: string | null, idContrato: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/projetos/servicos-ampliacao/${id}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
  getHistoricoAnalise(projectId:any, analiseId:any, pageIndex: number = 0){
    return this.http.get(
      this.baseUrl +
        `/v1/projetos/servicos-ampliacao/${projectId}/analises/${analiseId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
  getParametrosServicos(
    idContrato:any
  ) {
    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/ativos?page=0&size=10&sortDirection=asc&sortField=descricaoServico`);
  }

  getParametroServicoAmpliacao(idContrato: string, idParametroServicoAmpliacao: string) {
    return this.http.get(this.baseUrl + `/v1/contratos/${idContrato}/parametros-servicos-ampliacao/${idParametroServicoAmpliacao}`);
  }


  getAfericaoOperacional(idRelatorioContratual: string) {
    return this.http.get(this.baseUrl + `/v1/afericoes/relatorios-operacionais/${idRelatorioContratual}`);
  }

  getTiposInvestimentos() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-investimento?page=0&size=100&sortDirection=asc&sortField=nome&nome=&descricao=`
    );
  }
  getTiposProjetos() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-projeto?page=0&size=100&sortDirection=asc&sortField=id&nome=&descricao=`
    );
  }
  getContratos(){
    return this.http.get(
      this.baseUrl +
      `/v1/contracts/actives?page=0&size=1000&sortField=contractNumber&sortDirection=asc`
    );
  }
 getDocumentosAssinados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinados`
      , { params }
    );
  }
  getDocumentosComprovacao(
    idParametroServicoInicial: string,
    idDocumentoComprovacao: string,
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`
    );
  }
  getDocumentosPendentes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinaturas-pendentes`
      , { params }
    );
  }
  assinarDocumento(idParametroServicoInicial: any, idUsuarioAssinante: any,) {
    const data = {
      idUsuarioAssinante: idUsuarioAssinante
    }
    return this.http.post(`${this.baseUrl}/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinar`, data)
  }
  desvincularDisciplina(idProjeto: any,idDisciplinaProjeto: any) {
    return this.http.delete(`${this.baseUrl}/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplinaProjeto}`,)
  }
    getDetalhesItemAnalise(idParametroServicoInicial: string, idItemAnalise: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises/documentos/${idItemAnalise}`
    );
  }
    getAnaliseAfericoes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises`
      , { params }
    );
  }
    getFiltrosStatus() {
    return this.http.get<any[]>(this.baseUrl + `/v1/projetos/servicos-ampliacao/filtros-status`);
  }
  postTransicaoStatus(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao/processar-status`, formData);
  }
  postTransicaoStatusAnalise(idProjeto: string, formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/analises/processar-status`, formData);
  }
  postTransicaoStatusDisciplina(idProjeto: string, formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/processar-status`, formData);
  }
  getHistoricoDisciplina(idProjeto: string, idDisciplina: string, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
  getTiposParecerAnaliseProjeto() {
    return this.http.get<any[]>(this.baseUrl + `/v1/projetos/servicos-ampliacao/tipos-pareceres-analise`);
  }

  editarResponsavelAnalise(idProjeto: string, idAnalise: string, idResponsavel: string, prazo?: string | null) {
    const payload: any = { idResponsavel, prazo: prazo ?? null };
    return this.http.put(this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/analises/${idAnalise}`, payload);
  }

  getAnaliseDisciplina(
    pageSize: number = 10, pageIndex: any, sortDirection: any, sortProperty: any,
    idProjeto: string, idDisciplina: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '');
    return this.http.get(
      this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}/analises`,
      { params }
    );
  }

  postTransicaoStatusAnaliseDisciplina(idProjeto: string, idDisciplina: string, formData: FormData) {
    return this.http.post(
      this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}/analises/processar-status`,
      formData
    );
  }

  editarResponsavelAnaliseDisciplina(idProjeto: string, idDisciplina: string, idAnalise: string, idResponsavel: string, prazo?: string | null) {
    const payload: any = { idResponsavel, prazo: prazo ?? null };
    return this.http.put(
      this.baseUrl + `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}/analises/${idAnalise}`,
      payload
    );
  }

  getHistoricoAnaliseDisciplina(idProjeto: any, idDisciplina: any, analiseId: any, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
      `/v1/projetos/servicos-ampliacao/${idProjeto}/disciplinas/${idDisciplina}/analises/${analiseId}/historico?page=${pageIndex}&size=10&sortField=data&sortDirection=desc`
    );
  }
}
